export default {
  CREATE_APP: 'createApp',
  DELETE_APP: 'deleteApp',
  UPDATE_APP: 'updateApp',
  UPDATE_NAVIGATION: 'updateNavigation',
  CREATE_VERSION_APP: 'createVersionApp',
  CREATE_COPY_APP: 'createCopyApp',
  SELECT_VERSION_APP: 'selectVersionApp',
  CREATE_SECTION: 'createSection',
  UPDATE_SECTION: 'updateSection',
  DEPLOYMENT: 'deployment',
  DESIGNER_EXPERT: 'designerExpert',
  MANAGE_USERS: 'manageUsers',
  CAN_NOTIFY: 'canNotify',
  ADMIN: 'admin',
  PLAYER_ONLY: 'playerOnly',
  MANAGE_KEYS: 'manageApiKeys',
  MANAGE_FREMIUM: 'manageFreemium',
}

